// extracted by mini-css-extract-plugin
export default {"container":"GenreCard_container__pHFyf"};